<template>
  <div class="logo">
    <router-link :to="{path:'/'}">
    <div style="display:flex;align-items:center;height: 100%;">
        <img style="width: 55px;height: 55px;" src="@/assets/images/logo.png" alt="logo" />
        <div class="p-l-8 font-bold font-16">{{ projectName }}</div>
      </div>
    </router-link>
  </div>
</template>

<script>
export default {
  name: 'Logo',
  props: {
    showTitle: {
      type: Boolean,
      default: true,
      required: false
    }
  }
}
</script>
